import { isValid } from 'date-fns';
import { formatDefault } from '@/filters/formatDefault';
import { formatDateTime } from '@/filters/formatDateTime';
import { DateOptionTypes } from '@/types/types';

/**
 * @description format a given date to default or specific date format
 *
 * @param val string, date to be formatted
 * @param options object to define the format, and time display in locale or utc
 *
 * @return formatted date string or default format.
 */
export const formatDate = (val: string | null, options?: DateOptionTypes) => {
  if (!val || !isValid(new Date(val))) {
    return formatDefault(val);
  }
  const timeFormat = options?.format || 'yyyy-MM-dd';
  return formatDateTime(val, { format: timeFormat });
};
